__webpack_require__.p = "/summer-international/";